import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '../../../utils/comon';

const SearchBar = ({ 
    onSearch, 
    placeholder = "Search...", 
    debounceTime = 400, 
    className = "",
    initialValue = ""
}) => {
    const [searchTerm, setSearchTerm] = useState(initialValue);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (onSearch) onSearch(searchTerm);
        }, debounceTime);

        return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm, debounceTime]);

    return (
        <div className={`relative ${className}`}>
            <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input 
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-4 py-2 bg-white dark:bg-actionitembg border border-gray-200 dark:border-bordercolor rounded-lg text-xs font-medium text-[#0F172A] dark:text-textprimary focus:outline-none focus:ring-1 focus:border-gray-400 transition-all shadow-sm hover:border-gray-300"
                style={{ '--tw-ring-color': primaryColor() }}
            />
        </div>
    );
};

export default SearchBar;
